import { render, staticRenderFns } from "./QuoteOtherLabour.vue?vue&type=template&id=7b5b8ec0&scoped=true"
import script from "./QuoteOtherLabour.vue?vue&type=script&lang=js"
export * from "./QuoteOtherLabour.vue?vue&type=script&lang=js"
import style0 from "./QuoteOtherLabour.vue?vue&type=style&index=0&id=7b5b8ec0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5b8ec0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b5b8ec0')) {
      api.createRecord('7b5b8ec0', component.options)
    } else {
      api.reload('7b5b8ec0', component.options)
    }
    module.hot.accept("./QuoteOtherLabour.vue?vue&type=template&id=7b5b8ec0&scoped=true", function () {
      api.rerender('7b5b8ec0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/QuoteOtherLabour.vue"
export default component.exports